import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export default function useTextRouteQuery() {
  const [text, setText] = useState<string>();

  const router = useRouter();

  const searchParams = useSearchParams();

  useEffect(() => {
    const text = searchParams.get("text");

    if (!text) {
      return;
    }

    setText(text);

    router.replace("/feed/global");
  }, [setText, router, searchParams]);

  return { text, setText };
}
